import { render, staticRenderFns } from "./DocInspectorView.vue?vue&type=template&id=2101a76e&"
import script from "./DocInspectorView.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocInspectorView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports